import {
  setHubbleForms,
  setHubbleCurrentpage,
  setHubbleTotalPages,
  setHubbleTotalDocs,
  setSingleHubbleForm,
  setHubbleJudges,
  setHubbleReferee,
  setHubbleRefereeCurrentpage,
  setHubbleRefereeTotalPages,
  setHubbleRefereeTotalDocs,
  setSingleHubbleReferee,
} from "redux/actions/Hubble";
import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";

import axios from "../auth/jwt/config";

const HubbleRequests = {
  getHubbleList: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/hubble/getall?page=${page}&limit=10`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setHubbleForms(data.docs));
            dispatch(setHubbleCurrentpage(data.page));
            dispatch(setHubbleTotalPages(data.totalPages));
            dispatch(setHubbleTotalDocs(data.totalDocs));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },

  getHubbleFormById: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/hubble/getbyid/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleHubbleForm(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getJudgeList: () => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/hubbleRefereeUser/getall`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setHubbleJudges(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  addJudge: (nationalCode) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .post(`/hubbleRefereeUser/create`, { nationalCode: nationalCode })
          .then(() => {
            dispatch(fetchSuccess());
            dispatch(HubbleRequests.getJudgeList());
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeJudge: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .delete(`/hubbleRefereeUser/remove/${id}`)
          .then(() => {
            dispatch(fetchSuccess());
            dispatch(HubbleRequests.getJudgeList());
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getHubbleRefereeList: (page,owner) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/hubbleReferee/getall?page=${page}&limit=50&referee=${owner}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setHubbleReferee(data.docs));
            dispatch(setHubbleRefereeCurrentpage(data.page));
            dispatch(setHubbleRefereeTotalPages(data.totalPages));
            dispatch(setHubbleRefereeTotalDocs(data.totalDocs));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getHubbleRefereeById: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/hubbleReferee/getsingle/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleHubbleReferee(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default HubbleRequests;
